users.controller('CompanyHistoryController', ['$scope', 'companyHistoryResource', 'companyHistoryService', function ($scope, companyHistoryResource, companyHistoryService) {

    $scope.listName = 'CompanyHistoryList';

    companyHistoryService.scope = $scope;
    companyHistoryService.resourceParams = {id: $scope.$parent.data.id};
    $scope.gridOptions = companyHistoryService.getGridOptions();
    companyHistoryService.getPage();

}]);